export enum AssignmentType {
  INDIVIDUAL_ASSIGNMENT = 'INDIVIDUAL_ASSIGNMENT',
  GROUP_ASSIGNMENT = 'GROUP_ASSIGNMENT',
}

export type AssignmentFormData = {
  assignmentType?: AssignmentType;
  employeeId?: string;
  employeeGroupId?: StringOrNumber | null;
  ownerId?: string;
  target?: {
    id?: number;
    targetId?: number;
    type?: string;
    displayName?: string;
    budgetInfo?: {
      defaultBudget?: {
        name?: string;
      } | null;
    } | null;
  } | null;
  slotId?: StringOrNumber | null;
  roleOnProject?: string | null;
  membershipRole?: string | null;
  positionId?: StringOrNumber | null;
  technologyId?: StringOrNumber | null;
  competencyLevel?: string | null;
  minPercent?: number;
  maxPercent?: number;
  backup?: boolean;
  isSpof?: boolean;
  isSecondaryLead?: boolean;
  bench?: boolean;
  from?: string;
  to?: string;
  noteText?: string | null;
  backupForEmployeeId?: string | null;
  backupForEmployeeName?: string | null;
  budgetId?: StringOrNumber | null;
  budget?: {
    name?: string;
  } | null;
};

export type AssignmentEntityType = {
  ownerId: string;
  employeeId: string;
  azureId: string;
  roleOnProject: Nullable<string>;
  employeeEmail: string;
  resourceManagerId: Nullable<string>;
  from: string;
  to: string;
  minPercent: number;
  maxPercent: number;
  budgetId: number;
  employeeGroupId: Nullable<string>;
  assignmentType: AssignmentType;
  backup: boolean;
  backupForEmployeeId: Nullable<string>;
  bench: boolean;
  target: {
    id: number;
    targetId?: Nullable<number>;
    displayName: string;
    taskTrackerAlias: string;
    type: string;
    budgetInfo: any | null; // TODO
  };
  project?: Nullable<{ name: string }>;
  id: number;
  ownerName: string;
  ownerWorkingEmail: string;
  employeeName: string;
  resourceManagerName: Nullable<string>;
  position: {
    id: number;
    name: string;
    alias: string;
    vacancyAlias: string;
    createdAt: string;
    updatedAt: Nullable<string>;
    isLegacy: boolean;
  };
  technology: Nullable<string>;
  status: Nullable<string>;
  isVirtual: boolean;
  membershipRole: Nullable<string>;
  competencyLevel: Nullable<string>;
  slotId: Nullable<number>;
  noteText: Nullable<string>;
  createdById: string;
  createdByName: string;
  updatedById: string;
  updatedByName: string;
  canEdit: boolean;
  isSpof: boolean;
  isSecondaryLead: boolean;
  backupForEmployeeName: Nullable<string>;
  createdAt: string;
  updatedAt: string;
  budget: {
    id: number;
    name: string;
    periodFrom: string;
    periodTo: string;
    softPeriodFrom: Nullable<string>;
    commercial: boolean;
  };
  employeeGroup: any | null; // TODO
};
